import { render, staticRenderFns } from "./EditCombo.vue?vue&type=template&id=2235f488&"
import script from "./EditCombo.vue?vue&type=script&lang=js&"
export * from "./EditCombo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports